import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getNetworkAccessList } from "actions/dashboard";
import { SelectWifiNetwork } from "empower-energy-owner-components";

const SelectWifiNetworkModal = ({
  selectedUnit,
  onCancel,
  onClickSelectWifiNetwork,
}) => {
  const dispatch = useDispatch();

  const loading = useSelector((state) => state.dashboard?.networkAccessLoading);
  const list = useSelector((state) => state.dashboard?.networkAccessList);
  const networkSettings = useSelector(
    (state) => state.dashboard?.networkSettings
  );

  const fetchNetworkList = useCallback(() => {
    if (selectedUnit?.id) {
      dispatch(getNetworkAccessList(selectedUnit.id));
    }
  }, [dispatch, selectedUnit]);

  useEffect(() => {
    fetchNetworkList();
  }, [fetchNetworkList]);

  return (
    <SelectWifiNetwork
      loading={loading}
      list={list}
      networkSettings={networkSettings}
      onCancel={onCancel}
      onClickSelectWifiNetwork={onClickSelectWifiNetwork}
      onClickSearch={fetchNetworkList}
    />
  );
};

export default SelectWifiNetworkModal;
